import { atom } from 'jotai';
import { localStoragePrefix } from '@studio/constants/env-variables';
import supportedBrowsers from '../../../supportedBrowsers';

const currentUserAgent = navigator.userAgent;
const storedUserAgent = localStorage.getItem(`${localStoragePrefix}-user-agent`);

if (storedUserAgent !== currentUserAgent) {
  localStorage.setItem(`${localStoragePrefix}-user-agent`, currentUserAgent);
  localStorage.setItem(
    `${localStoragePrefix}-show-unsupported-browser-banner`,
    JSON.stringify(!supportedBrowsers.test(currentUserAgent))
  );
}

const showUnsupportedBrowserBanner = localStorage.getItem(`${localStoragePrefix}-show-unsupported-browser-banner`);

export const browserStateAtom = atom({
  isBrowserSupported: supportedBrowsers.test(currentUserAgent),
  userAgent: currentUserAgent,
  isUnsupportedBannerVisible:
    showUnsupportedBrowserBanner === null
      ? !supportedBrowsers.test(currentUserAgent)
      : showUnsupportedBrowserBanner === 'true',
});
